import { useEffect } from "react";

import { UseFormReturnType } from "@mantine/form";

import useDrawerUnsavedChanges from "@/encounters/hooks/useDrawerUnsavedChanges";

/**
 * Registers this physical exam with encounter-level unsaved checks (navigation blocker).
 * Call `markAsSaved()` after a successful save (e.g. at the end of `handleSubmit`).
 */
function usePhysicalExamUnsavedChanges<T extends Record<string, unknown>>(
  url: string,
  form: UseFormReturnType<T>,
  savedValues: T,
) {
  const { markAsSaved, markValuesAsSaved } = useDrawerUnsavedChanges(
    `physical-exam:${url}`,
    form,
    savedValues,
  );

  useEffect(() => {
    markValuesAsSaved(savedValues);
  }, [savedValues, markValuesAsSaved]);

  return { markAsSaved };
}

export default usePhysicalExamUnsavedChanges;
